import React from 'react';
import { css } from '@emotion/css';
import Box from '@mui/material/Box';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import cx from 'classnames';

import { BottomSheetProps, DrawerClassesType } from './types';

const bottomSheetRoot = css`
  .drawer-content {
    border-top-left-radius: 1.2rem;
    border-top-right-radius: 1.2rem;
    max-height: calc(100vh - 5%);
  }
`;

const DEFAULT_CLASSES: DrawerClassesType = {
  containerClassName: 'bg-bg-primary overflow-auto drawer-content',
  handleClassName:
    'absolute top-8 w-44 h-4 rounded-full mb-8 bg-interactive-secondary-hover self-center',
  paper: 'shadow-none bg-transparent',
  rootClassName: 'flex flex-col drawer-root relative',
};

const BottomSheet: React.FC<React.PropsWithChildren<BottomSheetProps>> = (props) => {
  // removing native props
  const {
    enableHandlePanningGesture,
    enablePanDownToClose,
    index,
    onAnimate,
    opacity,
    stackBehavior,
    style,
    ..._props
  } = props;
  const { children, classes = DEFAULT_CLASSES, className, ...rest } = _props;

  const { containerClassName, handleClassName, rootClassName, ...restClasses } = classes;

  return (
    <SwipeableDrawer
      anchor="bottom"
      className={cx(className, bottomSheetRoot)}
      classes={restClasses}
      {...rest}>
      <Box className={rootClassName ?? DEFAULT_CLASSES.rootClassName}>
        <Box className={handleClassName ?? DEFAULT_CLASSES.handleClassName} />
        <Box className={containerClassName ?? DEFAULT_CLASSES.containerClassName}>{children}</Box>
      </Box>
    </SwipeableDrawer>
  );
};

export default BottomSheet;
